import { render, staticRenderFns } from "./TicketPosPremium.vue?vue&type=template&id=6004eebc&scoped=true&"
import script from "./TicketPosPremium.vue?vue&type=script&lang=js&"
export * from "./TicketPosPremium.vue?vue&type=script&lang=js&"
import style0 from "./TicketPosPremium.vue?vue&type=style&index=0&id=6004eebc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6004eebc",
  null
  
)

export default component.exports